export const formatDate = (dateString: string | undefined): string => {
  if (!dateString) {
    return '';
  }

  const parsedDate = new Date(dateString);

  // Check if the parsedDate is a valid date
  if (isNaN(parsedDate.getTime())) {
    // If not valid, you can handle this case, e.g., return an error message
    return 'Invalid date';
  }

  let locale = 'cs-CZ'; // default to Czech Republic

  // Determine locale based on country using switch-case
  switch (window.country || process.env.REACT_APP_COUNTRY) {
    case 'cz':
      locale = 'cs-CZ';
      break;
    case 'hu':
      locale = 'hu-HU';
      break;
    case 'sk':
      locale = 'sk-SK';
      break;
    default:
      break;
  }

  // Format the date using the determined locale
  return parsedDate.toLocaleDateString(locale, {
    year: 'numeric',
    month: 'numeric',
    day: 'numeric',
  });
};
